import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { t } from 'i18next'
import CatalogImageInput from './CatalogImageInput'

function CatalogProductImageModal({ product, entityId, onClose, onChange }) {
  if (!product) return null

  const selectedUrl = product.customImageUrl || product.defaultImageUrl

  return (
    <Dialog
      open={Boolean(product)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="modal-catalog-product-image">
      <DialogTitle>{t('QUICK_LIST_CATALOG.IMAGE.MODAL_TITLE')}</DialogTitle>
      <DialogContent>
        <p className="catalog-modal-product">
          <strong>{product.productName}</strong> · {product.sku}
        </p>

        <CatalogImageInput
          id="productCustomImage"
          label={t('QUICK_LIST_CATALOG.IMAGE.CUSTOM')}
          value={product.customImageUrl}
          entityId={entityId}
          onChange={onChange}
          testId="product-custom-image"
        />

        <div className="form-group">
          <label>{t('QUICK_LIST_CATALOG.IMAGE.PIM_IMAGES')}</label>
          {product.images.length === 0 ? (
            <p
              className="quick-list-section-empty"
              data-testid="text-empty-pim-images-product">
              {t('QUICK_LIST_CATALOG.IMAGE.NO_PIM_IMAGES')}
            </p>
          ) : (
            <div className="catalog-gallery">
              {product.images.map((image, index) => {
                const isDefault = image.URL === product.defaultImageUrl
                // Elegir la principal del PIM equivale a no tener imagen personalizada.
                const nextValue = isDefault ? '' : image.URL
                return (
                  <button
                    key={image.ImageId || image.URL}
                    type="button"
                    className={`catalog-gallery-item catalog-gallery-option${
                      image.URL === selectedUrl ? ' is-selected' : ''
                    }`}
                    onClick={() => onChange(nextValue)}
                    data-testid={`btn-select-pim-image-${
                      image.ImageId || index
                    }`}>
                    <img src={image.URL} alt="" />
                    {isDefault && (
                      <span className="catalog-gallery-badge">
                        {t('QUICK_LIST_CATALOG.IMAGE.MAIN')}
                      </span>
                    )}
                  </button>
                )
              })}
            </div>
          )}
          <p className="catalog-help">
            {t('QUICK_LIST_CATALOG.IMAGE.PIM_HELP')}
          </p>
        </div>

        <div className="quick-list-information-actions">
          <button
            type="button"
            className="btn-save"
            onClick={onClose}
            data-testid="btn-close-product-image">
            {t('QUICK_LIST_CATALOG.IMAGE.CLOSE')}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default CatalogProductImageModal
